<template>
    <div ref="listBox" class="newsList-box">
        <Form ref="search" :model="formItem" :label-width="100" label-colon="：">
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="标题">
                        <Input v-model="formItem.custName"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="日期">
                        <DatePicker type="daterange" placement="bottom-end" :value="formItem.time" style="width:100%" @on-change="formTimeChange"></DatePicker>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="公司">
                        <Input v-model="formItem.company"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="重要性">
                        <Select v-model="formItem.importantFlag">
                            <Option :value="1" :key="1">一级</Option>
                            <Option :value="2" :key="2">二级</Option>
                            <Option :value="3" :key="3">三级</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="摘要">
                        <Input v-model="formItem.description"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 18}" class="search-btn" style="margin-bottom:10px">
                    <Button type="primary" @click="getTableList()">搜索</Button>
                    <Button style="margin-left:5px;" @click="clearSearch()">清空</Button>
                    <Button type="primary" style="margin-left:5px;" @click="uploadFile()" v-if="!isNew">上传</Button>
                </Col>
            </Row>
        </Form>
        <div ref="showTable" class="newsList-table">
            <Table row-key="id" :columns="columns" :data="tableData" border :height="THeight" :span-method="handleSpan" v-if="!isNew" :loading="tableLoading" :load-data="loadChildData" @on-expand-tree="rowExpand">
                <template slot-scope="data" slot="pushFlag">
                    <Button type="primary" size="small" v-if="data.row.pushFlag !== 1" @click="pushClick(data.row)">推送</Button>
                    <Button type="error" size="small" v-if="data.row.withdrawFlag === 1" @click="withdrawClick(data.row)">撤回</Button>
                </template>
            </Table>
            <Table row-key="id" :columns="columns" :data="tableData" border :height="THeight" v-if="isNew" :loading="tableLoading">
                <template slot-scope="data" slot="pushFlag">
                    <Button type="primary" size="small" v-if="data.row.pushFlag !== 1" @click="pushClick(data.row)">推送</Button>
                    <Button type="error" size="small" v-if="data.row.withdrawFlag === 1" @click="withdrawClick(data.row)">撤回</Button>
                </template>
            </Table>
        </div>
        <Modal v-model="uploadModal" title="资料上传" width="75" :styles='{"top": "30px"}'>
            <Form ref="modalData" :model="modalForm" :rules="ruleValidate" :label-width="110" label-colon="：">
                <Row>
                    <Col span="6">
                        <FormItem label="三级菜单" prop="catalog">
                            <Select v-model="modalForm.catalog" :disabled="modalForm.btnloading">
                                <Option v-for="item in catalogList" :value="item.thirdMenuID.toString()" :key="item.thirdMenuID">{{ item.thirdMenuName }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="日期" prop="time">
                            <DatePicker type="date" placement="bottom-end" style="width:100%" :value="modalForm.time" :disabled="modalForm.btnloading" @on-change="modalTimeChange"></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="公司/来源" prop="company">
                            <Input v-model="modalForm.company" :disabled="modalForm.btnloading"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="重要性" prop="important" :disabled="modalForm.btnloading">
                            <Rate v-model="modalForm.important" :disabled="modalForm.btnloading" :count="3" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="标题" prop="title">
                            <Input type="textarea" v-model="modalForm.title" :disabled="modalForm.btnloading"></Input>
                        </FormItem>
                    </Col>
                    <Col span="24" class="form-mb-10">
                        <FormItem label="摘要">
                            <Input type="textarea" v-model="modalForm.description" :disabled="modalForm.btnloading"></Input>
                        </FormItem>
                    </Col>
                    <Col span="24" class="form-mb-10">
                        <FormItem label="链接地址">
                            <Input type="textarea" v-model="modalForm.url" :disabled="modalForm.btnloading"></Input>
                        </FormItem>
                    </Col>
                    <Col span="24" v-if="!modalForm.file" class="form-mb-10">
                        <FormItem label="文件上传">
                            <Upload multiple type="drag" action="//jsonplaceholder.typicode.com/posts/"
                            :before-upload="beforeUpload" :show-upload-list="false" :disabled="modalForm.btnloading">
                                <div style="padding: 10px 0">
                                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                    <p>点击或者拖拽上传文件</p>
                                </div>
                            </Upload>
                        </FormItem>
                    </Col>
                    <Col span="24" v-if="modalForm.file">
                        <FormItem label="上传文件">
                            <div>{{modalForm.file.name}}<Icon type="md-close" class="clear-file" @click="clearFile"/></div>
                        </FormItem>
                    </Col>
                    <Col span="24" v-if="modalForm.file">
                        <FormItem label="文件类型">
                            <div v-html="modalForm.fileType"></div>
                        </FormItem>
                    </Col>
                    <Col span="24" class="form-mb-0">
                        <FormItem label="是否推送">
                            <Checkbox v-model="modalForm.pushFlag">推送</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="success" long :loading="modalForm.btnloading" @click="saveFile">保存</Button>
            </div>
        </Modal>
        <newsDetails :show.sync="detailsModal.show" :tData="detailsModal.data"></newsDetails>
    </div>
</template>

<script>
import api from '@/api/index';
import { timestampToYMD, timestampToHMS } from '@/assets/js/utils';
import newsDetails from '../../components/industryNews/newDetails.vue';
import { newInterval, otherInterval } from '../../config';
export default {
    components: {
        newsDetails
    },
    data() {
        return {
            switch1: '',
            formItem: {
                custName: '',
                time: [],
                company: '',
                importantFlag: '',
                description: ''
            },
            detailsModal: {
                show: false,
                data: {}
            },
            columns: [
                {
                    title: '三级菜单',
                    key: 'name',
                    width: '200',
                    tree: true,
                    render: (h, params) => {
                        if (params.row.badge) {
                            return h('Badge', { style: { marginTop: '5px' }, props: { dot: true } }, params.row.name);
                        };
                        return h('span', params.row.name);
                    }
                },
                {
                    title: '日期',
                    key: 'data',
                    align: 'center',
                    width: '130'
                }, {
                    title: '公司/来源',
                    key: 'c',
                    align: 'center',
                    width: '140',
                    render: (h, params) => {
                        return h('div', {
                            style: { whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', cursor: 'pointer' },
                            on: {
                                click: () => {
                                    this.formItem.company = params.row.c;
                                    this.getTableList();
                                }
                            }
                        }, params.row.c);
                    }
                }, {
                    title: '标题',
                    key: 'title',
                    minWidth: 200,
                    render: (h, params) => {
                        return h('div', {
                            style: { cursor: 'pointer' },
                            on: {
                                click: () => {
                                    this.detailsModal.show = true;
                                    this.detailsModal.data = { data: params.row };
                                }
                            }
                        }, params.row.title);
                    }
                }, {
                    title: '摘要',
                    key: 'description',
                    width: 200,
                    render: (h, params) => {
                        if (!params.row.description) {
                            return h('div');
                        }
                        return h('Tooltip', {
                            style: {
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden'
                            },
                            props: {
                                maxwidth: 300,
                                content: params.row.description
                            }
                        }, params.row.description);
                    }
                }, {
                    title: '重要性',
                    key: 'important',
                    align: 'center',
                    width: '100',
                    render: (h, params) => {
                        let num = parseInt(params.row.important);
                        let dom = h('div', {
                            style: {
                                cursor: 'pointer'
                            },
                            on: {
                                click: () => {
                                    this.formItem.importantFlag = num;
                                    this.getTableList();
                                }
                            }
                        }, []);
                        for (let i = num; i > 0; i--) {
                            dom.children.push(h('Icon', { props: { type: 'md-star', color: '#ff9900' } }));
                        }
                        return dom;
                    }
                }, {
                    title: '上传人',
                    key: 'person',
                    align: 'center',
                    width: '120'
                }, {
                    title: '推送',
                    key: 'file',
                    align: 'center',
                    width: '100',
                    slot: 'pushFlag'
                }, {
                    title: '是否微信推送',
                    key: 'wx',
                    align: 'center',
                    width: '100'
                }, {
                    title: '新信息',
                    key: 'new',
                    align: 'center',
                    width: '100',
                    render: (h, params) => {
                        if (params.row.new === '') {
                            return '';
                        }
                        return h('Tag', { props: { color: 'success' } }, params.row.new);
                    }
                }, {
                    title: '附件',
                    key: 'file',
                    align: 'center',
                    width: '100',
                    render: (h, params) => {
                        let dom = h('div', []);
                        if (!params.row.file.address) {
                            return dom;
                        }
                        dom.children.push(h('Icon', {
                            props: { type: 'ios-link' },
                            style: {
                                cursor: 'pointer'
                            },
                            on: {
                                click: () => {
                                    if (params.row.file.type === 'url') {
                                        window.open(params.row.file.address, '_blank');
                                        return;
                                    }
                                    this.detailsModal.show = true;
                                    this.detailsModal.data = params.row;
                                }
                            }
                        }));
                        return dom;
                    }
                }, {
                    title: '操作',
                    key: 'operation',
                    align: 'center',
                    width: '100',
                    render: (h, params) => {
                        let dom = h('div', []);
                        if (!params.row.creator || params.row.creator.id !== this.$store.state.user.id) {
                            return dom;
                        }
                        dom.children.push(h('Button', {
                            props: { type: 'error', size: 'small' },
                            on: {
                                click: () => {
                                    this.deleteDetails(params.row.id);
                                }
                            }
                        }, '删除'));
                        return dom;
                    }
                }
            ],
            tableData: [],
            loadTableData: [],
            uploadModal: false,
            modalForm: {
                catalog: '',
                time: timestampToYMD(new Date()),
                company: '',
                important: 0,
                title: '',
                fileType: '',
                file: null,
                url: '',
                btnloading: false,
                pushFlag: false
            },
            catalogList: [],
            ruleValidate: {
                catalog: [
                    { required: true, message: '请选择三级菜单', trigger: 'change' }
                ],
                time: [
                    { required: true, message: '请选择时间', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请填写公司', trigger: 'blur' }
                ],
                title: [
                    { required: true, message: '请填写标题', trigger: 'blur' }
                ]
            },
            pageId: '',
            THeight: 100,
            isNew: false,
            tableLoading: false
        };
    },
    watch: {
        '$route'(to, from) {
            this.pageId = this.$route.meta.id;
            if (this.pageId.toString() === '13') {
                this.isNew = true;
            } else {
                this.isNew = false;
            }
            this.getTableList();
            this.clearSearch();
            window.onresize();
            this.findBySecondMenuID();
        }
    },
    mounted() {
        this.pageId = this.$route.meta.id;
        if (this.pageId.toString() === '13') {
            this.isNew = true;
        } else {
            this.isNew = false;
        }
        setTimeout(() => {
            this.fixedTable();
        }, 0);
        this.windowOnresize();
        this.initialTime();
        this.findBySecondMenuID();
        this.getTableList();
    },
    methods: {
        fixedTable() {
            const pTop = this.$refs.search.$el.clientHeight;
            this.$refs.showTable.style.top = pTop + 'px';
            this.$refs.showTable.style.bottom = '0px';
            this.THeight = this.$refs.listBox.clientHeight - 10 - pTop;
        },
        windowOnresize() {
            window.onresize = () => {
                window.clearTimeout(this.timer);
                this.$refs.showTable.style.overflow = 'hidden';
                return (() => {
                    this.timer = setTimeout(() => {
                        this.fixedTable();
                        this.$refs.showTable.style.overflow = 'visible';
                    }, 100);
                })();
            };
        },
        getTableList() {
            if (this.isNew) {
                this.getNewsTableList();
                return;
            }
            this.getIndustryList();
        },
        async getNewsTableList() {
            this.tableLoading = true;
            let startData = new Date(this.formItem.time[0]);
            startData.setDate(startData.getDate() - 1);
            this.tableData = [];
            const res = await api.getIndustryList(timestampToYMD(startData) + ' 23:59:59', timestampToYMD(new Date()) + ' 23:59:59', 0, this.formItem.custName,
                this.formItem.company, this.formItem.importantFlag, this.formItem.description);
            this.tableLoading = false;
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({
                    background: true,
                    content: '获取列表出错'
                });
                return;
            }
            for (let val of res.data) {
                let file = {
                    type: 'url',
                    address: val.url
                };
                if (!val.fileName) {
                    file = {
                        type: 'file',
                        address: val.filePath + val.fileName
                    };
                }
                this.tableData.push({
                    id: val.industryDocID.toString(),
                    name: val.thirdMenu.thirdMenuName,
                    data: timestampToYMD(val.createDate),
                    c: val.companyName,
                    status: val.length,
                    it: 'true',
                    title: val.title,
                    important: val.importantFlag,
                    description: val.description,
                    creator: val.creator,
                    person: val.creator ? val.creator.username : '',
                    badge: false,
                    wx: val.pushFlag !== 0 ? '是' : '否',
                    today: timestampToYMD(val.createDate) === timestampToYMD(new Date()) ? 'NEW' : '',
                    new: !val.alreadyRead ? 'New' : '',
                    file: file,
                    pushFlag: val.pushFlag,
                    withdrawFlag: (val.pushNewTime && (new Date() - new Date(val.pushNewTime)) < 86400000) ? 1 : 0
                });
            }
        },
        // 获取到列表 qwertyuiop
        async getIndustryList() {
            this.tableData = [];
            this.loadTableData = [];
            let startData = new Date(this.formItem.time[0]);
            startData.setDate(startData.getDate() - 1);
            const res = await api.getIndustryList(timestampToYMD(startData) + ' 23:59:59', this.formItem.time[1] + ' 23:59:59', this.pageId, this.formItem.custName,
                this.formItem.company, this.formItem.importantFlag, this.formItem.description);
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({
                    background: true,
                    content: '获取列表出错'
                });
                return;
            }
            let dataMap = new Map();
            for (const date of res.data) {
                let childrenData = [];
                if (dataMap.has(date.thirdMenu.thirdMenuID)) {
                    childrenData = dataMap.get(date.thirdMenu.thirdMenuID);
                }
                childrenData.push(date);
                dataMap.set(date.thirdMenu.thirdMenuID, childrenData);
            }
            this.listToTreeList(dataMap);
        },
        // 对列表数据进行处理
        listToTreeList(map) {
            map.forEach((value, key) => {
                let parentList = {
                    id: key.toString(),
                    name: value[0].thirdMenu.thirdMenuName,
                    isFirst: true,
                    badge: false,
                    children: []
                };
                for (const key in value) {
                    let file = {
                        type: 'url',
                        address: value[key].url
                    };
                    if (value[key].fileName) {
                        file = {
                            type: 'file',
                            address: value[key].filePath + value[key].fileName
                        };
                    }
                    parentList.children.push({
                        id: value[key].industryDocID.toString(),
                        name: '',
                        data: timestampToYMD(value[key].createDate),
                        c: value[key].companyName,
                        status: value.length,
                        it: key === '0' ? 'true' : '',
                        title: value[key].title,
                        important: value[key].importantFlag,
                        creator: value[key].creator,
                        person: value[key].creator ? value[key].creator.username : '',
                        wx: value[key].pushFlag !== 0 ? '是' : '否',
                        description: value[key].description,
                        today: timestampToYMD(value[key].createDate) === timestampToYMD(new Date()) ? 'NEW' : '',
                        new: !value[key].alreadyRead ? 'New' : '',
                        file: file,
                        pushFlag: value[key].pushFlag,
                        withdrawFlag: (value[key].pushNewTime && (new Date() - new Date(value[key].pushNewTime)) < 86400000) ? 1 : 0
                    });
                    if (!value[key].alreadyRead) {
                        parentList.badge = true;
                    }
                }
                if (parentList.children.length === 0) {
                    parentList.name = '\xa0\xa0\xa0\xa0\xa0' + parentList.name;
                }
                this.loadTableData.push(parentList);
            });
            for (const item of this.loadTableData) {
                let value = JSON.parse(JSON.stringify(item));
                value.children = [];
                value._loading = false;
                this.tableData.push(value);
            }
        },
        loadChildData(item, callback) {
            let child = [];
            for (const value of this.loadTableData) {
                if (value.id === item.id) {
                    child = JSON.parse(JSON.stringify(value));
                    child = child.children;
                    break;
                }
            }
            callback(child);
        },
        rowExpand(rowKey, status) {
            if (status) {
                return;
            }
            for (const value of this.tableData) {
                if (value.id === rowKey) {
                    value.children = [];
                    value._loading = false;
                    value._showChildren = false;
                    break;
                }
            }
        },
        clearSearch() {
            this.initialTime();
            this.formItem.custName = '';
            this.formItem.company = '';
            this.formItem.importantFlag = '';
            this.formItem.description = '';
        },
        // 初始化搜索列表日期
        initialTime() {
            let date = new Date();
            this.formItem.time = [];
            if (this.pageId.toString() === '13') {
                date.setDate(date.getDate() - newInterval);
                this.formItem.time.push(timestampToYMD(date));
                this.formItem.time.push(timestampToYMD(new Date()));
            } else {
                date.setDate(date.getDate() - otherInterval);
                this.formItem.time.push(timestampToYMD(date));
                this.formItem.time.push(timestampToYMD(new Date()));
            }
        },
        // 获取第三级目录
        async findBySecondMenuID() {
            const res = await api.findBySecondMenuID(this.pageId);
            this.catalogList = res.data;
        },
        // 表格行合并功能
        handleSpan({ row, column, rowIndex, columnIndex }) {
            if (row.isFirst && columnIndex === 0) {
                return [1, 12];
            } else if (row.isFirst) {
                return [0, 0];
            }
            if (row.status !== undefined && row.it === 'true' && columnIndex === 0) {
                return [row.status, 1];
            } else if (row.status !== undefined && row.it === '' && columnIndex === 0) {
                return [0, 0];
            }
        },
        // 上传按钮点击
        uploadFile() {
            this.$refs.modalData.resetFields();
            this.uploadModal = true;
            this.modalForm = {
                catalog: '',
                time: timestampToYMD(new Date()),
                company: '',
                important: 0,
                title: '',
                fileType: '',
                file: null,
                btnloading: false,
                pushFlag: false
            };
        },
        // 拦截上传操作
        beforeUpload(file) {
            const fileTxt = file.name.split('.');
            if (fileTxt.length < 2) {
                this.file = null;
                this.$Message.warning({
                    background: true,
                    content: '上传文件出错'
                });
                return false;
            }
            const px = fileTxt[fileTxt.length - 1].toLowerCase();
            if (px !== 'doc' && px !== 'docx' && px !== 'pdf' && px !== 'xls' && px !== 'xlsx') {
                this.$Message.warning({
                    background: true,
                    content: '上传的文件类型不正确！'
                });
                return false;
            }
            this.modalForm.fileType = px;
            this.modalForm.file = file;
            return false;
        },
        // 清除已选择文件
        clearFile() {
            this.modalForm.file = null;
        },
        // 点击modal保存时
        saveFile() {
            this.$refs.modalData.validate((valid) => {
                if (valid) {
                    this.saveModalFile();
                }
            });
        },
        // 上传文件
        async saveModalFile() {
            this.modalForm.btnloading = true;
            const res = await api.addIndustryDoc(
                this.modalForm.catalog, this.modalForm.company, this.modalForm.title, this.modalForm.important,
                this.modalForm.description, this.modalForm.file, timestampToHMS(this.modalForm.time), this.modalForm.url, this.modalForm.pushFlag ? 1 : 0);
            if (res.code !== 200 && res.result !== 'success') {
                this.$Message.warning({
                    background: true,
                    content: '上传文件失败请重试！'
                });
                this.modalForm.btnloading = false;
                return;
            }
            this.$Message.success({
                background: true,
                content: res.msg
            });
            this.uploadModal = false;
            this.getTableList();
        },
        // Modal时间选择时触发
        modalTimeChange(time, date) {
            this.modalForm.time = timestampToYMD(time);
        },
        formTimeChange(time, date) {
            this.formItem.time = time;
        },
        pushClick(row) {
            this.$Modal.confirm({
                title: '提示',
                content: '内部资料，谨慎外传',
                onOk: () => {
                    this.weiXinPush(row.id);
                }
            });
        },
        // 推送
        async weiXinPush(id) {
            const res = await api.weiXinPush(id);
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({ background: true, content: res.msg });
                return;
            }
            this.$Message.success({ background: true, content: res.msg });
            this.getTableList();
        },

        deleteDetails(id) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '确定删除该条新闻？',
                onOk: () => {
                    this.deleteIndustryDoc(id);
                }
            });
        },
        // 删除新闻
        async deleteIndustryDoc(id) {
            const res = await api.deleteIndustryDoc(id);
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({ background: true, content: res.msg });
                return;
            }
            this.$Message.success({ background: true, content: res.msg });
            this.getTableList();
        },

        withdrawClick(data) {
            this.$Modal.confirm({
                title: '撤回确认',
                content: '确定撤回该条新闻？',
                onOk: () => {
                    this.withdrawNesw(data.id);
                }
            });
        },
        async withdrawNesw(id) {
            const res = await api.messageWithdrawn(id);
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({ background: true, content: res.msg });
                return;
            }
            this.$Message.success({ background: true, content: res.msg });
            this.getTableList();
        }
    }
};
</script>

<style scoped lang="scss">
.newsList-box {
    position: relative;
    height: 100%;
}
.search-btn {
    text-align: right;
}

.newShow-box {
    height: 100%;
    width: 100%;
    position: relative;
}

.newShow-tree {
    position: absolute;
    left: 0;
    width: 300px;
    height: 100%;
}

.newShow-table {
    position: absolute;
    left: 300px;
    right: 0;
    height: 100%;
}

.clear-file {
    cursor: pointer;
    margin-left: 10px;
    color: crimson;
}

.newsList-table {
    position: absolute;
    left: 0;
    right: 0;
}
</style>
<style scoped>
.newsList-box >>> .ivu-form-item {
    margin-bottom: 10px;
}
.newsList-table >>> .ivu-tooltip-inner {
    white-space: normal;
}
.newsList-table >>> .ivu-tooltip-rel {
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
